import {
  ApacCandidateHeaderFooterLinkProvider,
  ApacCandidateFooter,
} from '@seek/apac-candidate-header-footer';
import type { ApacHeaderFooterAuthenticationStatus } from '../App/App';
import { Link } from 'braid-design-system';

interface FooterProps {
  authenticationStatus: ApacHeaderFooterAuthenticationStatus;
}

const Footer = ({ authenticationStatus }: FooterProps) => {
  const customLinkComponent = {
    Link: (props: any) => <Link {...props} />,
    sendLinkEvent: () => {},
  };

  return (
    <ApacCandidateHeaderFooterLinkProvider value={customLinkComponent}>
      <ApacCandidateFooter
        isExpandedVersion={true}
        authenticationStatus={authenticationStatus}
        widthMode="large"
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Footer;
